'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _uniqid = _interopRequireDefault(require("uniqid"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Checkbox = _interopRequireDefault(require("Components/Forms/Elements/Checkbox"));
var _TextEditor = _interopRequireDefault(require("Components/Forms/Elements/TextEditor"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _DatePicker = _interopRequireDefault(require("Components/Forms/Elements/V2/DatePicker"));
var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _styles = require("@material-ui/core/styles");
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
const contract_type_options = [{
  value: "CDI",
  label: "CDI"
}, {
  value: "CDD",
  label: "CDD"
}, {
  value: "Apprentissage",
  label: "Apprentissage"
}, {
  value: "Stage",
  label: "Stage"
}, {
  value: "Autre",
  label: "Autre"
}];
const status_options = [{
  value: "Ouverte",
  label: "Ouverte"
}, {
  value: "Fermée",
  label: "Fermée"
}, {
  value: "Désactivée",
  label: "Désactivée"
}];
const duration_type_options = [{
  value: "Temps complet",
  label: "Temps complet"
}, {
  value: "Temps partiel",
  label: "Temps partiel"
}];
class JobAdBackForm extends _react.Component {
  state = {
    loading: false,
    status_messages: {},
    'jobad[status]': "Fermée",
    'jobad[handicap_mission]': false,
    'jobad[interested_candidates]': [],
    current_tab: 0
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchJobAd();
    } else {
      component.setState({
        'jobad[acceptation]': false
      });
    }
    component.fetchCompany();
    component.fetchCandidate();
    component.fetchProfessionalDomain();
  }
  fetchJobAd = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/job-ad/get-all', {
      id: props.id || document.location.pathname.split('/liste-des-annonces/')[1]
    }).then(function (xhr, response) {
      let interested_candidates = response.jobads[0].interested_candidates;
      delete response.jobads[0].interested_candidates;
      const update = (0, _getStateFromObject.default)({
        data: response.jobads[0],
        model: 'jobad'
      });
      component.setState({
        ...update,
        'jobad[interested_candidates]': interested_candidates,
        fetch_id: (0, _uniqid.default)(),
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCompany = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-all', {
      count: false
    }).then(function (xhr, response) {
      component.setState({
        companies: response.companies,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchCandidate = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-all', {
      count: false
    }).then(function (xhr, response) {
      component.setState({
        candidates: response.candidates,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  fetchProfessionalDomain = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    component.setState({
      loading: true
    });
    qwest.post('/professional-domain/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        professional_domains: response.professional_domains
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleTabChange = (event, value) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      current_tab: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const jobad = (0, _getFormData.default)({
      state: state,
      pattern: 'jobad['
    });
    const url = props.type === 'update' ? '/job-ad/update' : '/job-ad/create';
    qwest.post(url, jobad).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      window.setTimeout(function () {
        app.navigateTo('/liste-des-annonces/');
      }, 2000);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  handleCheckboxChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    if ([true, 'true'].includes(value)) {
      component.setState({
        [name]: value,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state[name];
      component.setState({
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  getCandidateData = candidate_id => {
    const component = this,
      props = this.props,
      state = this.state;
    let candidate = (state.candidates || []).find(candidate => candidate.id === candidate_id);
    return candidate;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let professional_domains_options = (state.professional_domains || []).sort(function (a, b) {
      let labelA = a.label.toLowerCase(),
        labelB = b.label.toLowerCase();
      if (labelA < labelB) return -1;
      if (labelA > labelB) return 1;
      return 0;
    }).map(function (professional_domain) {
      let option = {
        label: professional_domain.label,
        value: professional_domain.id
      };
      return option;
    });
    const company_options = (state.companies || []).map(function (company) {
      let option = {
        label: company.company_name,
        value: company.id
      };
      return option;
    });
    const interested_candidates_columns = [{
      id: 'lastname',
      sortable: false,
      numeric: false,
      label: 'Nom'
    }, {
      id: 'firstname',
      sortable: false,
      numeric: false,
      label: 'Prénom'
    }, {
      id: 'login',
      sortable: false,
      numeric: false,
      label: 'Email'
    }, {
      id: 'phone_number',
      sortable: false,
      numeric: false,
      label: 'Téléphone'
    }, {
      id: 'date',
      sortable: false,
      numeric: false,
      label: 'Date'
    }];
    let interested_candidates_list = (state['jobad[interested_candidates]'] || []).map(function (interested_candidate) {
      let candidate = component.getCandidateData(candidate.id);
      if (!candidate) return;
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: candidate.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, candidate.lastname), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, candidate.firstname), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, candidate.login), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, candidate.home_phone_number, ' ', candidate.phone_number), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, moment(interested_candidate.date).format('DD/MM/YYYY')));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/job-ad/create"
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: "tabs-paper",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Tabs.default, {
      value: state.current_tab,
      onChange: component.handleTabChange,
      name: "current_tab",
      variant: "scrollable",
      scrollButtons: "auto",
      indicatorColor: "primary",
      textColor: "primary"
    }, /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "D\xE9tails de l'annonce",
      value: 0
    }), /*#__PURE__*/_react.default.createElement(_Tab.default, {
      label: "Candidats ayant postul\xE9",
      value: 1
    }))), /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 0,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['jobad[company_id]'],
      name: "jobad[company_id]",
      label: "Entreprise",
      status: state.status_messages,
      options: company_options,
      "default-value": company_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['jobad[status]'],
      name: "jobad[status]",
      label: "Statut",
      status: state.status_messages,
      options: status_options,
      defaultValue: status_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['jobad[title]'],
      name: "jobad[title]",
      type: "text",
      label: "Intitul\xE9 du poste",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['jobad[salary]'],
      name: "jobad[salary]",
      type: "text",
      label: "Salaire",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['jobad[contract_type]'],
      name: "jobad[contract_type]",
      label: "Type de contrat",
      status: state.status_messages,
      options: contract_type_options,
      defaultValue: contract_type_options[0]?.value
    })), state['jobad[contract_type]'] !== 'CDI' ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['jobad[contract_duration]'],
      name: "jobad[contract_duration]",
      type: "text",
      label: "Dur\xE9e du contrat",
      status: state.status_messages
    })) : undefined, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['jobad[duration_type]'],
      name: "jobad[duration_type]",
      label: "Dur\xE9e de travail",
      status: state.status_messages,
      options: duration_type_options,
      defaultValue: duration_type_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Select.default, {
      onChange: component.handleChange,
      value: state['jobad[service]'],
      name: "jobad[service]",
      label: "Domaine professionnel",
      status: state.status_messages,
      options: professional_domains_options,
      defaultValue: professional_domains_options[0]?.value
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
      onChange: component.handleChange,
      value: state['jobad[start_date]'],
      name: "jobad[start_date]",
      label: "Date de d\xE9but",
      status: state.status_messages?.['jobad[start_date]']?.error,
      key: state.fetch_id
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["jobad[required_skill]"] || '',
      name: "jobad[required_skill]",
      label: "Comp\xE9tence(s) souhait\xE9e(s)",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["jobad[required_experience]"] || '',
      name: "jobad[required_experience]",
      label: "Exp\xE9rience(s) souhait\xE9e(s)",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/_react.default.createElement(_TextEditor.default, {
      onChange: component.handleChange,
      value: state["jobad[job_description]"] || '',
      name: "jobad[job_description]",
      label: "Description du poste",
      multiline: true,
      rows: "2",
      "without-headings": true,
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      label: "Code postal",
      onChange: component.handleChange,
      value: state['jobad[address][postal_code]'],
      name: "jobad[address][postal_code]",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Existence d\u2019une mission \xAB handicap \xBB ou d\u2019un r\xE9f\xE9rent \xAB handicap \xBB",
      name: "jobad[handicap_mission]",
      value: state['jobad[handicap_mission]'] === true,
      status: state.status_messages
    })), props.type !== 'update' ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      onChange: component.handleCheckboxChange,
      label: "Nous acceptons que l\u2019insertion de la personne dans notre entreprise/organisme soit accompagn\xE9e par Aspiejob ",
      name: "jobad[acceptation]",
      value: state['jobad[acceptation]'] === true,
      status: state.status_messages
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_core.Paper, {
      className: "o-back-content candidate-paper",
      hidden: state.current_tab !== 1,
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Suivi de statut",
      className: "u-margin-bottom-25"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      columns: interested_candidates_columns,
      order: "undefined",
      order_by: "undefined",
      row_count: interested_candidates_list.length
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, interested_candidates_list))), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-50 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cette annonce', loader)), status);
    return output;
  }
}
exports.default = JobAdBackForm;
